import React, { useContext, useEffect, useMemo } from "react";
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  usePagination,
} from "react-table";
import ColumnFilter from "../../supplier/tables/ColumnFilter";
import GlobalFilter from "../../supplier/tables/GlobalFilter";
import { useNavigate } from "react-router-dom";
import { MdEdit } from "react-icons/md";
import { AiOutlineFilePdf } from "react-icons/ai";
import logo from "../../../assets/logo.avif";
import { LoginContext } from "../../../reactcontext/ReactContext";

function AgentTable({
  data,
  columns,
  setFormData,
  formData,
  openModal,
  handleDelete,
  dLoading,
}) {
  const navigate = useNavigate();
  const { loginInfo } = useContext(LoginContext);

  const printedBy = loginInfo?.userDetails
    ? `${loginInfo.userDetails.firstName} ${loginInfo.userDetails.lastName}`
    : 'Admin';

  function getReadableTimestamp() {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
  }

  const exportPDF = () => {
    if (!data || data.length === 0) { alert('No data available to export.'); return; }
    const html2pdf = require('html2pdf.js');
    const tdStyle = 'padding:4px 6px;border:1px solid #e5e7eb;';
    const rows = data.map((r, i) => `
      <tr style="background:${i % 2 === 0 ? '#fff' : '#f9fafb'}">
        <td style="${tdStyle}">${r.name || 'N/A'}</td>
        <td style="${tdStyle}">${r.mobile || 'N/A'}</td>
        <td style="${tdStyle}">${r.email || 'N/A'}</td>
        <td style="${tdStyle}">${r.gender || 'N/A'}</td>
        <td style="${tdStyle}">${r.nationality || 'N/A'}</td>
        <td style="${tdStyle}">${r.Employees?.length ?? 0}</td>
      </tr>`).join('');
    const el = document.createElement('div');
    el.style.cssText = 'padding:20px;font-family:Arial,sans-serif;font-size:11px;';
    el.innerHTML = `
      <div style="text-align:center;margin-bottom:14px;">
        <img src="${logo}" style="width:60px;display:block;margin:0 auto 6px auto;" crossorigin="anonymous"/>
        <div style="font-size:16px;font-weight:bold;margin:4px 0;">Rahman Group</div>
        <div style="font-size:13px;margin:2px 0;">Report Listing - Agents</div>
      </div>
      <div style="display:flex;gap:30px;flex-wrap:wrap;margin-bottom:12px;">
        <span><em>Printed By:</em> <strong>${printedBy}</strong></span>
        <span><em>Printed On:</em> <strong>${getReadableTimestamp()}</strong></span>
        <span><em>Total Records:</em> <strong>${data.length}</strong></span>
        <span><em>Signature:</em> <strong>______________</strong></span>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:10px;">
        <thead><tr style="background:#e5e7eb;">
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Agent Name</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Phone</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Email</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Gender</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Nationality</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Profiles</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`;
    html2pdf().set({
      margin: 10,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    }).from(el).outputPdf('blob').then(blob => {
      window.open(URL.createObjectURL(blob), '_blank');
    });
  };

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      ...columns,
      {
        Header: "Actions",
        Footer: "Actions",
        accessor: "actions",
        Cell: ({ row }) => {
          return (
            <div className="flex flex-row items-center gap-[3px]">
              <button onClick={() => handleDetails(row.values)} className="">
                <MdEdit fontSize={28} color="green"/>
              </button>
              {/* <button 
                onClick={() => deleteRecord(row.values)} 
                className="p-2 border-2 rounded-xl bg-red-300 shadow-lg">
                  { dLoading ? "Processing" : "Delete"}
        </button>*/}
            </div>
          );
        },
        disableFilters: true,
      },
    ]);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data, defaultColumn },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    tableHooks
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const handleDetails = (data1) => {
    setFormData({
      ...formData,
      id: data1.id,
      name: data1.name,
      mobile: data1.mobile,
      email: data1.email,
      address: data1.address,
      gender: data1.gender,
      nationality: data1.nationality,
    });
    openModal();
  };

  const deleteRecord = (data1) => {
    setFormData({
      ...formData,
      id: data1.id,
      name: data1.name,
      mobile: data1.mobile,
      email: data1.email,
    });
    handleDelete(data1.id);
  };

  const handleOtherDetails = (data1) => {
    const queryString = new URLSearchParams({
      agentData: JSON.stringify({ id: data1.id, name: data1.name }),
    }).toString();
    navigate(`/agentProfile?${queryString}`);
  };

  useEffect(() => {
    setPageSize(5);
  }, []);

  return (
    <>
      <div className="w-full py-4">
        <div className="mb-4 flex flex-col sm:flex-row gap-4 items-center justify-between">
          <div className="w-full sm:max-w-md">
            <div className="relative">
              <GlobalFilter
                filter={globalFilter}
                setFilter={setGlobalFilter}
                placeholderText={"Search agents"}
                className="w-full pl-12 pr-4 py-3 rounded-full shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent text-gray-700 font-medium border border-gray-300 bg-white transition-all duration-200 hover:shadow-xl"
              />
              <div className="absolute top-1/2 left-4 transform -translate-y-1/2 inline-flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 text-gray-400"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="10" cy="10" r="7" />
                  <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
              </div>
            </div>
          </div>
          <button
            onClick={exportPDF}
            disabled={!data || data.length === 0}
            className={`p-2 gap-1 flex items-center justify-center text-sm rounded-md shadow font-light ${
              !data || data.length === 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600 text-white'
            }`}
          >
            <AiOutlineFilePdf fontSize={20} />
            Export PDF
          </button>
        </div>

        <div className="w-full bg-white rounded-lg shadow border border-gray-200">
          <table
            {...getTableProps()}
            className="w-full table-fixed border-collapse text-xs sm:text-sm"
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="text-left bg-gray-100"
                >
                  {headerGroup.headers.map((col) => {
                    const hideBelow = ['email'].includes(col.id) ? 'hidden lg:table-cell'
                      : ['gender', 'nationality'].includes(col.id) ? 'hidden md:table-cell'
                      : '';
                    const colWidth = {
                      id: '5%', name: '20%', mobile: '13%', email: '18%',
                      gender: '8%', nationality: '11%', 'Employees.length': '10%', actions: '10%',
                    }[col.id] || 'auto';
                    return (
                      <th
                        {...col.getHeaderProps(col.getSortByToggleProps())}
                        style={{ width: colWidth }}
                        className={`bg-gray-100 sticky top-0 border-b border-gray-200 px-1 sm:px-2 lg:px-3 py-2 sm:py-3 text-gray-600 font-bold tracking-wider uppercase text-[10px] sm:text-xs leading-tight select-none break-words ${hideBelow}`}
                        key={col.id}
                      >
                        {col.render("Header")}
                        <span className="ml-0.5 text-gray-400">
                          {col.isSorted ? (col.isSortedDesc ? "▼" : "▲") : ""}
                        </span>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="border-t border-gray-100 hover:bg-gray-50 transition duration-150"
                    key={row.id}
                  >
                    {row.cells.map((cell) => {
                      const hideBelow = ['email'].includes(cell.column.id) ? 'hidden lg:table-cell'
                        : ['gender', 'nationality'].includes(cell.column.id) ? 'hidden md:table-cell'
                        : '';
                      return (
                        <td
                          {...cell.getCellProps()}
                          className={`px-1 sm:px-2 lg:px-3 py-2 sm:py-3 text-gray-700 truncate overflow-hidden border-t border-gray-100 ${hideBelow}`}
                          key={cell.column.id}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-between items-center py-4">
          <span>
            Page{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <div className="flex gap-2">
            <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
            >
              {"<<"}
            </button>
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
            >
              Previous
            </button>
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
            >
              Next
            </button>
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
              className="px-3 py-1 bg-gray-200 rounded text-gray-600 hover:bg-gray-300 disabled:bg-gray-100"
            >
              {">>"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AgentTable;
